'use client'

import { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { useAppStore } from "@/lib/store/app-store";

// maplibre-gl touches `window` at module-eval time, which crashes Next's
// server-side prerender — this component (and its map) is client-only.
const AllMatchesPerDay = dynamic(
  () => import("@/components/custom/matches/all-matches-per-day").then((m) => m.AllMatchesPerDay),
  { ssr: false }
);

function DateTimeBadge() {
  const timezone = useAppStore((s) => s.timezone);
  // Starts null so server render and first client paint match exactly (no
  // Date/Intl evaluated yet); the real clock kicks in once mounted.
  const [now, setNow] = useState<Date | null>(null);

  useEffect(() => {
    setNow(new Date());
    const id = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(id);
  }, []);

  const dateLabel = now?.toLocaleDateString("en-CA", {
    year: "numeric", month: "2-digit", day: "2-digit", timeZone: timezone,
  }) ?? "—";

  const timeLabel = now?.toLocaleTimeString("en-GB", {
    hour: "2-digit", minute: "2-digit", timeZone: timezone, hour12: false,
  }) ?? "—";

  return (
    <div
      className="inline-flex items-center gap-2 rounded-full border border-white/10 px-3 py-1"
      style={{ background: "#0e1114" }}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-green-400" />
      <span className="text-xs text-white/55">
        {dateLabel} · {timeLabel}
      </span>
    </div>
  );
}

export function Home() {
  return (
    <div className="py-6 space-y-6">
      <DateTimeBadge />
      <AllMatchesPerDay />
    </div>
  );
}
